import React from 'react';
import './StatCard.css';

/**
 * StatCard - Tarjeta para mostrar estadísticas
 * Reutilizable en toda la aplicación
 */
const StatCard = ({ 
  title, 
  value, 
  change, 
  trend, 
  icon,
  onClick,
  loading = false,
  className = ''
}) => {
  return (
    <div 
      className={`stat-card ${onClick ? 'clickable' : ''} ${loading ? 'loading' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="stat-header">
        <span className="stat-title">{title}</span>
        {icon && <span className="stat-icon">{icon}</span>}
      </div>
      
      <div className="stat-content">
        {loading ? (
          <div className="skeleton-loader"></div>
        ) : (
          <>
            <div className="stat-value">{value}</div>
            {change && (
              <div className={`stat-change ${trend || 'neutral'}`}>
                <span className="change-arrow">
                  {trend === 'up' ? '↑' : trend === 'down' ? '↓' : '→'}
                </span>
                <span className="change-value">{change}</span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default StatCard;
